import { render, staticRenderFns } from "./ChronicAbsenceDetails.vue?vue&type=template&id=5262e265&scoped=true"
import script from "./ChronicAbsenceDetails.vue?vue&type=script&lang=js"
export * from "./ChronicAbsenceDetails.vue?vue&type=script&lang=js"
import style0 from "./ChronicAbsenceDetails.vue?vue&type=style&index=0&id=5262e265&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5262e265",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog,VSlideYTransition,VSpacer})
